export default defineAppConfig({
  authCookieName: 'appstore_session',
  panelBaseUrl: 'https://app.sendcloud.com',
  accountBaseUrl: 'https://account.sendcloud.com',
  signUpLink: 'https://account.sendcloud.com/signup/',
  ecosystemLink: 'https://www.sendcloud.com/ecosystem/',
})
